import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { PremiumContentIcon } from 'src/components/global/PremiumContentIcon/PremiumContentIcon'
import { IEnum_Content_Contenttype } from 'src/graphql/generated/hooks'
import { useDefaultLogo } from 'src/hooks/useDefaultLogo'
import { isContentItem, isContentListItemFragment } from 'src/utils/ContentDataFragment'
import { getContentDefaultImageUrl } from 'src/utils/getContentDefaultImageUrl'
export interface RelatedContentListItemProps {
  item: any
}

export const RelatedContentListItem: React.FC<RelatedContentListItemProps> = ({ item }) => {
  const contentType = isContentListItemFragment(item)
    ? item.attributes?.contentType
    : isContentItem(item)
      ? item.contentType
      : IEnum_Content_Contenttype.VendorResource
  const title = (isContentListItemFragment(item) ? item.attributes?.title : item.title) || ''
  const defaultImageUrl = getContentDefaultImageUrl(item)
  const shouldShowDefaultImage =
    contentType &&
    [
      IEnum_Content_Contenttype.Blog,
      IEnum_Content_Contenttype.IndustryAnalysis,
      IEnum_Content_Contenttype.VendorResource,
      IEnum_Content_Contenttype.KnowHow,
      IEnum_Content_Contenttype.LegaltechResourcesForLawyers,
      IEnum_Content_Contenttype.BuyersGuide,
    ].includes(contentType)

  const url = isContentListItemFragment(item)
    ? item.attributes?.slug
      ? item.attributes.contentType === IEnum_Content_Contenttype.IndustryAnalysis
        ? `/industry-analysis/${item.attributes?.slug}`
        : `/contents/${item.attributes?.slug}`
      : null
    : isContentItem(item)
      ? `/contents/${item.slug}`
      : item.link
  // const isInternalLink = isContentListItemFragment(item) || isContentItem(item)
  const logo = useDefaultLogo(defaultImageUrl)

  const logoContent = (
    <>
      {shouldShowDefaultImage && defaultImageUrl ? (
        <Image
          className="bg-white rounded-[.5rem] drop-shadow-md flex items-center justify-center w-[18px] h-[18px] min-w-[18px] min-h-[18px]"
          src={defaultImageUrl}
          alt={title}
          width={18}
          height={18}
          priority
        />
      ) : contentType ? (
        <PremiumContentIcon contentType={contentType} size="18" defaultImage={defaultImageUrl} />
      ) : (
        <Image
          className="bg-white rounded-[.5rem] drop-shadow-md flex items-center justify-center w-[18px] h-[18px] min-w-[18px] min-h-[18px]"
          src={logo}
          alt={title}
          width={18}
          height={18}
          priority
        />
      )}
    </>
  )

  return (
    <li className="flex items-center space-x-2 mb-[4px]">
      <span>
        {url && (
          <Link prefetch={false} className="text-left" href={url}>
            {logoContent}
          </Link>
        )}
        {!url && <div className="text-left">{logoContent}</div>}
      </span>
      <Link
        prefetch={false}
        href={url}
        title={item.title}
        className="h-[22px] font-secondary font-medium text-[15px] text-darkgray cursor-pointer underline overflow-hidden max-w-xs inline-block align-middle whitespace-nowrap truncate"
      >
        {item.title?.length > 30 ? `${item.title.slice(0, 27)}...` : item.title}
      </Link>
    </li>
  )
}
